// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PhotosUploadScreen":"qt_a bie_ea bie_qt bie_a bie_w"};